import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Tooltip } from 'antd';
import SwitchInvestigation from './SwitchInvestigation';
import DownloadSite from './DownloadSite';
import API_URL from "../../common/url";
import $ from "../../common/AjaxRequest";
import ExportUtil from '../../common/ExportUtil';
import ENV from '../../common/env.js';
import { actions } from '../../actions/inProjectActions';
import { saveParams } from '../../actions/investigationActions';
import './style/layout.less';

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formVisible: false,
            countNotice: 0,
        };
        
        // 刷新浏览器，将 项目列表状态、项目数据 信息重新存入store
        const { settlementType, investigationState } = sessionStorage;
        const { saveParams, switchStatistical } = props;
        if (investigationState) {
            saveParams(JSON.parse(investigationState));
            sessionStorage.removeItem('investigationState');
        }
        if (settlementType) {
            switchStatistical(settlementType);
            sessionStorage.removeItem('settlementType');
        }
    }

    clickChangeSite = () => {
        this.switchInvestigationRef.show();
    }
    clickDownloadSite = () => {
        this.DownloadSite.show();
    }
    clickMine = () => {
        const { invId, siteId } = sessionStorage;
        if (siteId > 0 || invId > 0) {
            this.clickBack();
        }
        location.href = '#/personal/information';
    }
    
    saveSessionparams = ()=>{
        const path = location.hash.substr(1);
        if(path == '/executeMgr/visitPeriodPlan') // 访视周期页面未保存跳转其他页面，需要恢复原有的参数配置
        {
            localStorage.curSession = JSON.stringify(sessionStorage);
        }
    }

    clickBack = () => {
        this.saveSessionparams();
        this.props.saveParams({ feedBack: true });
        if (sessionStorage.siteId > 0 || sessionStorage.invId > 0) {
            sessionStorage.siteId = '';
            sessionStorage.invId = '';
            sessionStorage.curRole = sessionStorage.positionRole;
            sessionStorage.investigationSiteName = '';
            sessionStorage.investigationSiteCode = '';
            location.href = `#/invList`;
        }
    }

    exit = () => {
        const tokenName = localStorage.tokenName;
        const tokenValue = localStorage.tokenValue;
        const loginType = localStorage.loginType || 'ADFS';
        
        this.saveSessionparams();
        const options = {
            url: `${API_URL.config.logout}`,
            data: {
                [tokenName]: tokenValue,
                loginType,
            },
            dataType: 'json',
            doneResult: (data => {
                const { redirectUrl } = data;
                sessionStorage.clear();
                localStorage.clear();
                location.href = redirectUrl;
            }),
        };
        $.sendRequest(options);
    }


    updateInvestigationState = investigationId => {
        const options = {
            url: `${API_URL.investigation.getBaseInfo}`,
            data: {
                investigationId,
            },
            dataType: 'json',
            doneResult: (data => {
                if (data.investigation) {
                    sessionStorage.invStatus = data.investigation.investigationStatus;
                    sessionStorage.completeTime = data.investigation.completeTime;
                }
            }),
        };
        $.sendRequest(options);
    }

    changeInvAndRoleAndSite = (params) => {
        for (let [key, value] of Object.entries(params)) {
            sessionStorage[key] = value;
        }

        const { feedBack, pagination, searchParams, settlementType } = this.props;
        sessionStorage.settlementType = settlementType;
        sessionStorage.investigationState = JSON.stringify({ feedBack, pagination, searchParams });
        location.reload();
    }

    clearSite = () => {
        sessionStorage.siteId = 0;
        sessionStorage.investigationSiteCode = "";
        sessionStorage.investigationSiteName = "";
    }

    clearInv = () => {
        sessionStorage.invId = '';
        sessionStorage.invName = "";
        sessionStorage.invSpecialName = "";
    }

    cleanSession = () => {
        const path = location.hash.substr(1);
        const startWith = (str) => {
            return path.startsWith(str);
        }
        //匹配Route的Path，在特定页面清空特定session
        if (startWith('/siteList')) {
            this.clearSite();
        }
        if (startWith('/invList') || startWith('/home') || startWith('/manHour') || startWith('/user') || startWith('/hospital')) {
            this.clearSite();
            this.clearInv();
        }
    };

    // hash 切换路径节流（60s，距上次成功请求）；事件路径 refreshCountNotice 旁路节流，保证处理通知后即时刷新
    lastCountNoticeAt = 0

    loadCountNotice = () => {
        if (!sessionStorage.userId) {
            return;
        }
        if (Date.now() - this.lastCountNoticeAt < 60 * 1000) {
            return;
        }
        this.loadCountNoticeForce();
    }

    loadCountNoticeForce = () => {
        if (!sessionStorage.userId) {
            return;
        }
        const options = {
            method: 'POST',
            url: API_URL.home.queryCountTodayNoticeAllNew,
            data: {},
            dataType: 'json',
            doneResult: data => {
                this.lastCountNoticeAt = Date.now();
                this.setState({ countNotice: data.count });
            }
        }
        $.sendRequest(options);
    };

    refreshCountNotice = () => {
        this.loadCountNoticeForce();
    }

    exportHandleBook = () => {
        let url = API_URL.home.getHandbookFtp;
        ExportUtil.export(null, null, url);
    }

    componentDidMount() {
        this.loadCountNotice();
        window.addEventListener('smo:notice-count-refresh', this.refreshCountNotice);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.hash !== this.props.hash) {
            this.loadCountNotice();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('smo:notice-count-refresh', this.refreshCountNotice);
    }
    
    // componentWillUnmount(){
    //     localStorage.clear();
    // }

    roleNames = {
        CTA: 'smoCTA',
        VP: '副总裁',
        FIN: '财务',
        BO: '总监',
        BDO: 'BD总监',
        TAL: '领域leader',
        BDM: 'BDM',
        BD: 'BD',
        BA: 'BA',
        BAL: 'BAL',
        PA: '项目管理员',
        PM: '项目经理',
        CRCM: 'CRC经理',
        CRCC: 'CRC主管',
        CRC: '临床协调员',
        PML: 'PML',
        CSA: 'CSA',
        CSAL: 'CSAL',
        KAM: '大客户经理',
    }

    render() {
        const { countNotice } = this.state;
        const { invId, invName, siteId, curRole, userName, positionName, investigationSiteName, investigationSiteCode, isKeyAccountManager } = sessionStorage;
        this.cleanSession();
        let roleName = '';
        const newCurRole = (curRole === 'TAL' && isKeyAccountManager === 'true') ? 'KAM' : curRole;
        if (invId > 0 && curRole) {
            roleName = this.roleNames[newCurRole] || '其他';
        } else {
            roleName = positionName || '';
        }
        let siteName = '';
        if (investigationSiteName) {
            siteName = investigationSiteName;
            if (investigationSiteCode) {
                siteName += '(' + investigationSiteCode + ')';
            }
        }
        return (
            <header className="header">
                <div className="wrapper">
                    <h1 className="logo">
                        <img src={require('../../../public/logo.png')} alt="" />
                    </h1>
                    <h2 className="slogan">临床试验管理系统欢迎您！</h2>
                    <ul className="topnav">
                        {
                            (siteId > 0 || invId > 0)
                            && <li onClick={this.clickChangeSite}>
                                <span className="icon-wrap">
                                    <i className="icon iconfont">&#xe612;</i>
                                </span>
                                <span className="txt">切换</span>
                            </li>
                        }
                        {
                            (siteId > 0 || invId > 0) &&
                            <li onClick={this.clickBack}>
                                <span className="icon-wrap">
                                    <i className="icon iconfont">&#xe63d;</i>
                                </span>
                                <span className="txt">返回</span>
                            </li>
                        }
                        <li>
                            <a href="#/notice">
                                <span className="icon-wrap">
                                    <i className="icon iconfont">&#xe657;</i>
                                </span>
                                <span className="txt">消息</span>
                                {
                                    countNotice ? <span className="count">{countNotice}</span> : null
                                }

                            </a>
                        </li>
                        {
                            curRole == 'CTA' ?
                                <li>
                                    <a href="#/setting">
                                        <span className="icon-wrap">
                                            <i className="icon iconfont">&#xe607;</i>
                                        </span>
                                        <span className="txt">设置</span>
                                    </a>
                                </li>
                            :
                                <li>
                                    <a onClick={this.clickMine}>
                                        <span className="icon-wrap">
                                            <i className="icon iconfont">&#xe664;</i>
                                        </span>
                                        <span className="txt">我的</span>
                                    </a>
                                </li>
                        }
                        <li onClick={this.clickDownloadSite}>
                                <span className="icon-wrap">
                                    <i className="icon iconfont">&#xe676;</i>
                                </span>
                                <span className="txt">下载站</span>
                        </li>
                        <li>
                            <a onClick={this.exportHandleBook}>
                                <span className="icon-wrap">
                                    <i className="icon iconfont">&#xe61d;</i>
                                </span>
                                <span className="txt">手册</span>
                            </a>
                        </li>
                        <li onClick={this.exit}>
                            <span className="icon-wrap">
                                <i className="icon iconfont">&#xe72e;</i>
                            </span>
                            <span className="txt">退出</span>
                        </li>
                    </ul>
                    <div className="login-info-user">
                        <div className="vertical-div">
                            <div className="vertical-content">
                                <div className="p2">
                                    {curRole != 'CTA' && <span className="user-name">{userName || ''}</span>}
                                    <span className="user-title">{roleName}</span>
                                </div>
                                {
                                    invId > 0 &&
                                    <Tooltip overlayClassName="head_tip" title={invName != 'null' && invName}>
                                        <div className="p2">{invName || ''}</div>
                                    </Tooltip>

                                }
                                <br />
                                {
                                    siteName &&
                                    <Tooltip overlayClassName="head_tip" title={siteName}>
                                        <div className="p2">{siteName}</div>
                                    </Tooltip>
                                }
                            </div>
                        </div>
                    </div>
                    <SwitchInvestigation ref={el => this.switchInvestigationRef = el} onChange={this.changeInvAndRoleAndSite} />
                    <DownloadSite ref={el => this.DownloadSite = el}  />
                </div>
            </header>
        );
    }
}

const mapSateToProps = (state) => ({
    feedBack: state.investigationState.feedBack || false,
    pagination: state.investigationState.pagination || {},
    searchParams: state.investigationState.searchParams || {},
    settlementType: state.inProjectState.settlementType,
});

const mapDispatchToProps = (dispatch) => ({
    saveParams: (params) => dispatch(saveParams(params)),
    switchStatistical: (params) => dispatch(actions.switchStatistical(params)),
});

export default connect(mapSateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/layout/Header.js